var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-container"},[_c('div',{ref:"hot_ref",staticClass:"com-chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }